/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

const ROOT = '/permits';

export const splashPageRoute = () => '/tree-permits';
export const permitRoute = (permitId = ':permitId') => `${ROOT}/${permitId}`;
export const venuePageRoute = (permitId = ':permitId') => `/tree-permits/${permitId}`;
export const orderPageRoute = (permitId = ':permitId') =>
    `/tree-permits/${permitId}/order`;

export const orderDetailsPageRoute = (
    permitId = ':permitId',
    reservationId = ':reservationId'
) => `${permitRoute(permitId)}/order-details${reservationId ? `/${reservationId}` : ''}`;

const childRoutes = [
    {
        path: '/tree-permits/scanned',
        componentName: 'TreePermit',
    },
    {
        path: '/tree-permits/:treePermitId/order',
        componentName: 'TreePermitOrderDetailsPage',
    },
    {
        path: '/tree-permits/:treePermitId/reservation/:reservationId',
        componentName: 'TreePermitOrderDetailsPage',
    },
    {
        path: '/treepermit/:treePermitId/reservation/:reservationId',
        componentName: 'TreePermitOrderDetailsPage',
    },
    {
        path: '/tree-permits/:treePermitId',
        componentName: 'TreePermitDetailsPage',
    },
    {
        path: '/tree-permits',
        componentName: 'TreePermit',
    },
];

export default childRoutes;
